import { useMutation } from '@tanstack/react-query';

import { createOrder } from './services';

export const useCreateOrderMutation = () =>
  useMutation({
    mutationFn: orderData => createOrder(orderData),
  });
